"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconChevronDown = function IconChevronDown(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.7081 32.29C25.3173 32.6818 24.6827 32.6818 24.2919 32.29L13.711 21.6798C13.0824 21.0495 13.5289 19.9737 14.4191 19.9737L35.5809 19.9737C36.4711 19.9737 36.9176 21.0495 36.289 21.6798L25.7081 32.29Z",
    fill: color
  }));
};

IconChevronDown.defaultProps = {
  color: 'black',
  size: 30
};
IconChevronDown.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string,
  size: _propTypes.number
};
var _default = IconChevronDown;
exports.default = _default;